import { render, staticRenderFns } from "./BookingSuccess.vue?vue&type=template&id=57492f30&scoped=true&"
var script = {}
import style0 from "./BookingSuccess.vue?vue&type=style&index=0&id=57492f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57492f30",
  null
  
)

export default component.exports